import { combineReducers } from 'redux'
import store from 'common/ducks/store/general/store'
import product from 'common/ducks/product'
import storeProducts from 'common/ducks/store/product'
import contentRelatedProducts from 'common/ducks/news/contentRelatedProduct'
import serverRendered from 'common/ducks/serverRendered'
import scrollKept from 'common/ducks/scroll/scrollKept'
import scrollRestoredSelf from 'common/ducks/scroll/scrollRestoredSelf'
import infiniteGridScrollTop from 'common/ducks/scroll/infiniteGridScrollTop'
import articleDetail from 'common/ducks/news/articleDetail'
import storeCategories from 'common/ducks/store/category'
import listSort from 'common/ducks/list/sort'
import listFilter from 'common/ducks/list/filter'
import keywords from 'common/ducks/list/keywords'
import storeView from 'common/ducks/store/view'
import storeZzim from 'common/ducks/store/zzim'
import brandNews from 'common/ducks/store/brandNews'
import breadcrumbs from 'common/ducks/breadcrumb'
import storeTalktalk from 'common/ducks/store/talktalk'
import globalPopupLayer from 'common/ducks/popupLayer'
import storeBenefits from 'common/ducks/store/general/benefit'
import storeGrades from 'common/ducks/store/general/grade'
import news from 'common/ducks/store/news'
import storeBrands from 'common/ducks/store/brand'
import coordiLayer, { CoordiLayerState } from 'common/ducks/coordiLayer'
import storeContentSort from 'common/ducks/store/fashionBrand/contentSort'
import storeContentFilter from 'common/ducks/store/fashionBrand/contentFilter'
import designerStoreContentTabs from 'common/ducks/store/designer/contentTab'
import zzimProducts from 'common/ducks/product/zzim'
import compositeList from 'common/ducks/list/compositeList'
import productQna from 'common/ducks/product/qna'
import autoComplete from 'common/ducks/gnb/autoComplete'
import gnb, { GnbState } from 'pc/components/Common/Header/ducks/gnb'
import { CommonState } from 'common/types'
import selectedOptions from 'common/ducks/product/option'
import certification from 'common/ducks/certification'
import addressBook from 'common/ducks/product/address'
import locationKept from 'common/ducks/locationKept'
import myCouponCounts from 'common/ducks/my/coupon'
import myOrderDeliveryCounts from 'common/ducks/my/orderDelievery'
import myPoints from 'common/ducks/my/point'
import myWritableReviews from 'common/ducks/my/review'
import registerReviewReducer from 'common/ducks/review/registerReview'
import { flipReducer } from 'common/utils/flipState'
import branch from 'common/ducks/branch/branch'
import flipState from 'common/ducks/flipState'
import menu from 'common/ducks/menu'
import events from 'common/ducks/event/event'
import storeCategory from 'common/ducks/storeCategory'
import stores from 'common/ducks/store'
import mapStores from 'common/ducks/map/store'
import mapSort from 'common/ducks/map/sort'
import mapState from 'common/ducks/map/state'
import mapList from 'common/ducks/map/list'
import windowBrand from 'common/ducks/brand'
import specialEventDetail from 'common/ducks/event/specialEventDetail'
import recommendedTag from 'common/ducks/recommendedTag'
import storeBrandFilter from 'common/ducks/personalization/storeBrandFilter'
import naverMember from 'common/ducks/naverMember'
import myLocation from 'common/ducks/map/myLocation'
import collectionProducts from 'common/ducks/event/collectionProducts'
import serverLocationPath from 'common/ducks/serverLocationPath'
import serverReferer from 'common/ducks/serverReferer'
import relationProduct from 'common/ducks/relationProduct'
import storeRelationProduct from 'common/ducks/store/relationProduct'
import listItems from 'common/ducks/list/productList'
import aiTems from 'common/ducks/product/aiTems'
import randomNo from 'common/ducks/random'
import relationProductsZzimReducer from 'common/ducks/product/relationZzim'
import coordiProducts from 'common/ducks/product/coordi'
import hasRelationProductReducer from 'common/ducks/store/general/display'
import myInfo from 'common/ducks/my/personalInfo'
import pagedMyReview from 'common/ducks/review/pagedMyReview'
import photoVideoReviewIds from 'common/ducks/review/photoVideoReviewIds'
import generalReviewIds from 'common/ducks/review/generalReviewIds'
import reviewEvaluation from 'common/ducks/review/evaluation'
import reviewsFilter from 'common/ducks/review/reviewsFilter'
import pagedProductReview from 'common/ducks/review/pagedProductReview'
import productBestReview from 'common/ducks/review/productBestReview'
import payMemberStatusReducer from 'common/ducks/my/payMemberStatus'
import modifyReviewReducer from 'common/ducks/review/modifyReview'
import template from 'common/ducks/template'
import externalProducts from 'common/ducks/external/externalProducts'
import photoVideos from 'common/ducks/review/photoVideos'
import myAddress from 'common/ducks/personalization/myAddress'
import brandListReducer from 'common/ducks/brand/brandList'
import brandCardReducer from 'common/ducks/brand/brandCard'
import brandProfileReducer from 'common/ducks/brand/brand'
import bannerReducer from 'common/ducks/banner'
import storeMenu from 'common/ducks/storeMenu'
import subVerticalByPathname from 'common/ducks/subVerticalByPathname'
import newsListState from 'common/ducks/news/newsList'
import movingBanner from 'common/ducks/home/homemeal/movingBanner'
import menuByRegion from 'common/ducks/home/homemeal/menuByRegion'
import menuByIngredients from 'common/ducks/home/homemeal/menuByIngredients'
import logeye from 'common/ducks/product/logeye'
import recommendReview from 'common/ducks/review/recommendReview'
import compositeMenu from 'common/ducks/compositeMenu'
import isGifAnimation from 'common/ducks/list/gifAnimation'
import menuByKeyword from 'common/ducks/home/directfarm/menuByKeyword'
import simpleList from 'common/ducks/list/simpleList'

export interface RootState extends CommonState {
  gnb: GnbState
  coordiLayer: CoordiLayerState
}

export default combineReducers({
  gnb,
  scrollKept,
  scrollRestoredSelf,
  serverRendered,
  autoComplete,
  keywords,
  globalPopupLayer,
  coordiLayer,
  locationKept,
  infiniteGridScrollTop,
  compositeList,
  flipState,
  windowBrand,
  naverMember,
  myLocation,
  serverLocationPath,
  serverReferer,
  randomNo,
  myAddress,
  subVerticalByPathname,
  movingBanner,
  menuByRegion,
  menuByIngredients,
  isGifAnimation,
  brands: flipReducer(brandListReducer),
  brandCards: flipReducer(brandCardReducer),
  brandProfile: flipReducer(brandProfileReducer),
  menu: flipReducer(menu),
  store: flipReducer(store),
  breadcrumbs: flipReducer(breadcrumbs),
  certification: flipReducer(certification),
  coordiProducts: flipReducer(coordiProducts),
  addressBook: flipReducer(addressBook),
  product: flipReducer(product),
  selectedOptions: flipReducer(selectedOptions),
  productQna: flipReducer(productQna),
  zzimProducts: flipReducer(zzimProducts),
  zzimRelationProducts: flipReducer(relationProductsZzimReducer),
  storeBrands: flipReducer(storeBrands),
  brandNews: flipReducer(brandNews),
  storeCategories: flipReducer(storeCategories),
  listFilter: flipReducer(listFilter),
  news: flipReducer(news),
  storeProducts: flipReducer(storeProducts),
  contentRelatedProducts: flipReducer(contentRelatedProducts),
  listSort: flipReducer(listSort),
  storeTalktalk: flipReducer(storeTalktalk),
  storeView: flipReducer(storeView),
  storeZzim: flipReducer(storeZzim),
  designerStoreContentTabs: flipReducer(designerStoreContentTabs),
  storeContentFilter: flipReducer(storeContentFilter),
  storeContentSort: flipReducer(storeContentSort),
  articleDetail: flipReducer(articleDetail),
  storeBenefits: flipReducer(storeBenefits),
  storeGrades: flipReducer(storeGrades),
  branch: flipReducer(branch),
  events: flipReducer(events),
  storeCategory: flipReducer(storeCategory),
  mapStores: flipReducer(mapStores),
  stores: flipReducer(stores),
  mapSort: flipReducer(mapSort),
  mapState: flipReducer(mapState),
  mapList: flipReducer(mapList),
  aiTems: flipReducer(aiTems),
  storeBrandFilter: flipReducer(storeBrandFilter),
  specialEventDetail: flipReducer(specialEventDetail),
  recommendedTag: flipReducer(recommendedTag),
  collectionProducts: flipReducer(collectionProducts),
  relationProduct: flipReducer(relationProduct),
  storeRelationProduct: flipReducer(storeRelationProduct),
  listItems: flipReducer(listItems),
  hasRelationProduct: flipReducer(hasRelationProductReducer),
  myPoints: flipReducer(myPoints),
  myCouponCounts: flipReducer(myCouponCounts),
  myOrderDeliveryCounts: flipReducer(myOrderDeliveryCounts),
  writableReviews: flipReducer(myWritableReviews),
  myInfo: flipReducer(myInfo),
  pagedMyReview: flipReducer(pagedMyReview),
  registerReview: flipReducer(registerReviewReducer),
  modifyReview: flipReducer(modifyReviewReducer),
  photoVideoReviewIds: flipReducer(photoVideoReviewIds),
  generalReviewIds: flipReducer(generalReviewIds),
  reviewEvaluation: flipReducer(reviewEvaluation),
  reviewsFilter: flipReducer(reviewsFilter),
  pagedProductReview: flipReducer(pagedProductReview),
  productBestReview: flipReducer(productBestReview),
  payMemberStatus: flipReducer(payMemberStatusReducer),
  template: flipReducer(template),
  externalProducts: flipReducer(externalProducts),
  photoVideos: flipReducer(photoVideos),
  windowsBanners: flipReducer(bannerReducer),
  storeMenuState: flipReducer(storeMenu),
  logeye: flipReducer(logeye),
  recommendReview: flipReducer(recommendReview),
  compositeMenu: flipReducer(compositeMenu),
  menuByKeyword: flipReducer(menuByKeyword),
  newsListState: flipReducer(newsListState),
  simpleList: flipReducer(simpleList),
})
